import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import OwnerDashboard from "@/pages/OwnerDashboard";
import VaultAI from "@/pages/VaultAI";

function App() {
    return (
        <CartProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/payment/cancel" element={<PaymentCancel />} />
                    <Route path="/owner" element={<OwnerDashboard />} />
                    <Route path="/vault-ai" element={<VaultAI />} />
                </Routes>
            </BrowserRouter>
            <Toaster theme="light" position="bottom-right" />
        </CartProvider>
    );
}

export default App;
